import * as Sentry from '@sentry/react'
import { replayPrivacyFor } from '@/shared/diagnostics/replay-privacy'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Los eventos salen por NUESTRO dominio y nginx los reenvía a Sentry (ver `nginx.conf`).
  //
  // Sin esto, Sentry está CIEGO para cualquiera que tenga un bloqueador: uBlock, Brave Shields
  // y compañía traen los endpoints de `*.ingest.sentry.io` en sus listas de telemetría y matan
  // el POST antes de que salga a la red. Medido en producción: la request moría con
  // `net::ERR_BLOCKED_BY_CLIENT`, 0 kB, 0 ms. Los bloqueadores filtran por DOMINIO, así que una
  // ruta propia pasa.
  //
  // Lo peligroso no es perder eventos: es que "cero errores reportados" se lee igual que
  // "todo bien". El agujero era silencioso y sesgaba toda la telemetría hacia las máquinas
  // sin bloqueador.
  tunnel: '/monitoring',
  // `MODE` valía `production` en staging, porque Railway compila los dos con `vite build`. Se usa
  // el entorno normalizado en build (`development` | `staging` | `production`, ver `vite.config.js`).
  environment: __APP_ENVIRONMENT__,
  // La versión del build: `VITE_RELEASE` si está, y si no el SHA del deploy (`vite-plugin-app-version`).
  release: __APP_VERSION__,
  // La cuota de Sentry (5k errores/mes) se comparte entre los tres proyectos: se muestrea poco
  // (ADR 0042).
  tracesSampleRate: 0.1,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    // Producción enmascara todo el texto y bloquea medios (datos personales de clientes, y Sentry
    // es un tercero); staging y desarrollo no. Ver `replay-privacy.ts`.
    Sentry.replayIntegration(replayPrivacyFor(__APP_ENVIRONMENT__))
  ],
  // Sin replays de sesiones sanas: son 50 al mes en el plan gratuito. Sólo los que terminan en error.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0
})
